const updates = [
  {
    id: 1,
    title: '某流量明星深夜发文道歉，评论区瞬间炸锅',
    time: '10分钟前',
    tag: '突发',
    tagStyle: 'bg-primary-500 text-background-50',
  },
  {
    id: 2,
    title: '热门综艺最新一期收视率出炉，创本季新高',
    time: '28分钟前',
    tag: '数据',
    tagStyle: 'bg-accent-100 text-accent-800',
  },
  {
    id: 3,
    title: '某知名导演新片选角名单曝光，多位一线在列',
    time: '1小时前',
    tag: '独家',
    tagStyle: 'bg-primary-500 text-background-50',
  },
  {
    id: 4,
    title: '短视频平台大V涉嫌虚假宣传被平台封禁',
    time: '2小时前',
    tag: '快讯',
    tagStyle: 'bg-accent-100 text-accent-800',
  },
  {
    id: 5,
    title: '某女团成员合约纠纷最新进展，公司发声明回应',
    time: '3小时前',
    tag: '追踪',
    tagStyle: 'bg-secondary-100 text-secondary-800',
  },
  {
    id: 6,
    title: '年度十大娱乐事件评选投票通道正式开启',
    time: '4小时前',
    tag: '活动',
    tagStyle: 'bg-accent-100 text-accent-800',
  },
  {
    id: 7,
    title: '某品牌因广告争议连夜撤下全线物料',
    time: '5小时前',
    tag: '快讯',
    tagStyle: 'bg-accent-100 text-accent-800',
  },
  {
    id: 8,
    title: '某视频平台会员数突破新高，内容策略受关注',
    time: '6小时前',
    tag: '行业',
    tagStyle: 'bg-secondary-100 text-secondary-800',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            最新快讯
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            实时追踪51黑料在线观看的最新内容动态
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, idx) => (
            <div
              key={item.id}
              className="relative pl-8 pb-6 last:pb-0 group cursor-pointer"
            >
              <div className="absolute left-0 top-1.5 w-3 h-3 rounded-full border-2 border-accent-500 bg-background-50 z-10"></div>
              {idx < updates.length - 1 && (
                <div className="absolute left-[5px] top-4 bottom-0 w-0.5 bg-background-200"></div>
              )}
              <div className="flex flex-col sm:flex-row sm:items-start gap-2 sm:gap-4 transition-all hover:translate-x-1">
                <span
                  className={`text-[10px] px-2 py-0.5 rounded-full font-medium self-start flex-shrink-0 whitespace-nowrap ${item.tagStyle}`}
                >
                  {item.tag}
                </span>
                <div className="flex-1 min-w-0">
                  <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors leading-snug">
                    {item.title}
                  </h3>
                  <span className="text-xs text-foreground-500 mt-1 block">{item.time}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}